import { TransitEnterexitRounded } from '@material-ui/icons';
import { HISTORY,
         INFO,
         STATS,
         TIMES,
		 CONSTS,
         } from '../util/object'
import { initTables,
         loadImage,
         calcPixel2Meter,
         calcPixel2Femur,
         calcFemur2Pixel,
         NOW,
         calcMoveVector } from "../util/util";
import {
		 displayText,
         } from '../util/annotate'
import { setFrameEvent,
         calcMeter2Pixel,
		 } from '../util/util'

/* determine current player speed, direction, x_position
//     - 
//
// ref: processPositionTurnVectors()
export function playerMotionVector() {*/


var dfconsole_log = (false) ? console.log : () => {};		// true will disable console.log
var dfconsole_log1 = (false) ? console.log : () => {};		// true will disable console.log

// determine defender x_position
//     - on direction change, add a cognition delay before action (over run)
//     - rate of speed up from zero is limited by def_acc acceleration rate
//     - f0: current frame
//     - f1: prev frame
//     - base: last turn
//
export function DefenderPosition(f0, f1, base) {
    var dx, dy;
	var hidx = HISTORY.length - 1;
    var bhidx = (base) ? base.hidx : null;

    var pose = f0.pose;
    var trail = f0.trail;
    var action = f0.action;
    var action1 = f1.action;
    var defender1 = f1.defender;

    var dt = f0.timestamp - f1.timestamp;
    var dtb = (base) ? f0.timestamp - base.timestamp : null;
    var pspeed = action.body_speed;
    var pdegree = action.body_degree;
    //console.log("player.44:        . . . PLAYER VECTOR   hidx=",hidx, " px=",px, " py=",py, " pdist=",pdist, " pspeed=",pspeed.toFixed(2), " pdegree=",pdegree, " pflip=",pflip);

    //    - move towards player position
    //    - accelerate based on DEFENDR_COGNITON_DELAY curve, do not exceed
    //    - do not exceed player speed
    //
    var dpy = (defender1.top) ? defender1.top : 0;
    var dpx = (defender1.left) ? defender1.left : (INFO.image_width / 2);
    var ppy = pose.top;      //.ctr_y;
    var ppx = pose.ctr_x;


    var bpx = f0.trail.pbasex;     // use f.trail.pbasex at the last turn

    //var bpx = (base) ? base.trail.pbasex : null;     // use f.trail.pbasex at the last turn
    //var bpx = (poseb) ? poseb.ctr_x : null;     // 




    var sign = ((ppx - dpx) >= 0) ? 1 : -1;
    //INFO.defend_max_dx_psec = calcMeter2Pixel(STATS.pixel_ratio, INFO.defend_acc);     // use femur to conver meter to pixels

    var gap_dx =  Math.abs(dpx - ppx);
    var max_dx = INFO.defend_max_dx_psec * (dt / 1000);      // Note: Need to accont for femur scale
    var dx0 = (gap_dx > max_dx) ? (sign * max_dx) : (sign * gap_dx);      // do not exceed max acceleration of this bot

    var dxb = (bpx) ? Math.abs(ppx - bpx) : null;
    var tfemur = (dxb) ? calcPixel2Femur(dxb) : 0;

    //var pspeed0 = trail.pspeed;     // PLAYER speed 
    var pspeed0 = action.body_speed;     // PLAYER speed 
    var tspeed0 = (dxb) ? (tfemur / (dtb / 1000)) : -1;     // PLAYER speed since TURN started
    var tdist = (dxb) ? dxb : -1;     // PLAYER distance from TURN (x direction ONLY!)

    //console.log("def.76:                                       . . .     hidx=",hidx, " bhidx=",bhidx,"   ppx=",ppx, " bpx=", bpx, " dtb=",dtb, " pspd0=",pspeed0.toFixed(3), " tdist=",tdist, " now=",Date.now()%100000/1000);

    // NOTE: SHOULD DETECT THIS AT LOOP END, LOOK BACK HISTORY TO HIGHEST SPEED

    //console.log("player.70:                   - - - - -    tfemur=",tfemur.toFixed(2), "  dxb=",dxb, " femur=",parseInt(INFO.ref_femur));
    if ((TIMES.reached_2femur == 0) && (tfemur >= 2)) {
        TIMES.reached_2femur = Date.now();  // TODO: May need to prorate to get more precise time?
		setFrameEvent("2FEM-"+tfemur.toFixed(2));       // DEBUG ONLY
        console.log("femur.75:        REACHED 2FEMUR     - - - - -    tfemur=",tfemur.toFixed(2), "  dxb=",dxb, " femur=",parseInt(INFO.ref_femur));
    }





    var max_err = (100 - CONSTS.DEFENDER_FOLLOW_ACCURACY) / 100;       // introduce tracking error
    var errpct0 = Math.random() * max_err;
    var errpct = errpct0 - (max_err / 2);       // could be + or -
    var errx = parseInt(dx0 * errpct);
    dx = dx0 + errx;
    //console.log("player.82:             ERR     hidx=",hidx, "   max_err=",(max_err).toFixed(2), " errpct0=",(errpct0).toFixed(2), " errpct=",(errpct).toFixed(2), " errx=",parseInt(errx), " dx0=",parseInt(dx0));

    //var giveupx = calcMeter2Pixel(STATS.pixel_ratio, INFO.defend_gap);      // Note: use meter not % of screen
    var giveupx = calcFemur2Pixel(INFO.defend_gap);      // Note: use meter not % of screen
    var diffx = Math.abs(pose.ctr_x - defender1.left);
    //if ((hidx > 30) && (diffx > giveupx) && (pspeed > CONSTS.DEFENDER_PLAYER_MIN_SPEED)) {
    if ((hidx > 30) && (diffx > giveupx) && (tspeed0 > CONSTS.DEFENDER_JUKE_MIN_SPEED) && (INFO.defend_tot_turns > 0)) {
        // defender gave up
        //
        console.log("player.42:       !  !  !  !   DEFENDER GAVE UP!!!!   hidx=",hidx,  " giveupx=",parseInt(giveupx), " diffx=",parseInt(diffx), " pose.ctr_x=",pose.ctr_x, " def.x=", parseInt(defender1.left), " pspd=",pspeed.toFixed(2), " pdeg=",pdegree, " px_ratio=",parseInt(STATS.pixel_ratio), " femur=",parseInt(INFO.ref_femur));
        console.log("play.58:                  # . . #     tspd=",tspeed0.toFixed(2)," pspd=",pspeed.toFixed(2), " pdeg=",pdegree, " ppx=",parseInt(ppx), " dpx=",parseInt(dpx), 
                " dx=",parseInt(dx), " gap_dx=",parseInt(gap_dx), " max_dx=",parseInt(max_dx), " errx=",errx, " dt=",dt, " sign=",sign, " restart=",INFO.defend_restart_time);
        return [ null, null, tspeed0, tdist ];
    }


    if (INFO.defend_gave_up === false) {

        // in cognition freeze, continue moving in same vector
        //
        if (f0.timestamp < INFO.defend_restart_time) {
            var cdt = INFO.defend_restart_time - f0.timestamp;  // time left
            dx = INFO.defend_dx_ps * (dt / 1000);     // adjust dx to be same velocity
            dy = 0;
            dfconsole_log("player.65:     COGNITION WAIT  hidx=",hidx,  "         cdt=",cdt, " dx=",parseInt(dx), " dt=",dt, " defend_dx_ps=",parseInt(INFO.defend_dx_ps),
                        " f0.t=",f0.timestamp, "  restart=", INFO.defend_restart_time);
            dfconsole_log("play.58:                  # . . #     tspd=",tspeed0, " pspd=",pspeed.toFixed(2), " pdeg=",pdegree, " ppx=",parseInt(ppx), " dpx=",parseInt(dpx), 
                    " dx=",parseInt(dx), " gap_dx=",parseInt(gap_dx), " max_dx=",parseInt(max_dx), " errx=",errx, " dt=",dt, " sign=",sign, " restart=",INFO.defend_restart_time);
            return [ dx, dy, tspeed0, tdist ];

        } else {

            // determine defender position based on player movement
            //
            INFO.defend_restart_time = 0;
            INFO.defend_dx_ps = action1.defend_dx_ps;       // take snapshot in case of cognition delay
            //console.log("play.92:          * * * * SET DX_PS    dx_ps=",INFO.defend_dx_ps);
        }


        // adjust height base on rough hueristics
        //
        if(defender1.height > 0) {
            if(pose.ctr_y < dpy) {
                if(ppy < (dpy - 200)){
                    dy = ((ppy - dpy) / 2); // player is far back, don't follow
                } else {
                    dy = ((ppy - dpy) / 40); // be in front of the player
                }
            } else {
                if(ppy > dpy){
                    dy = (ppy - dpy) / 3;       // defender too high, back up fast
                } else {
                    dy = ((ppy - dpy) / 50);
                }
            }
        } else {
            dy = 0;     // don't know what to do
        }

    }


    dfconsole_log("p.92:  # # # DEFENDER hidx=",hidx, " bidx=",bhidx," tspd=",tspeed0.toFixed(2), " pspd=",pspeed.toFixed(2), " pdeg=",pdegree, 
                " ppx=",parseInt(ppx), " dpx=",parseInt(dpx), " dx=",parseInt(dx), " gap_dx=",parseInt(gap_dx), " mxdx=",parseInt(max_dx), 
                " erx=",errx, " dt=",dt, " dtb=",dtb," sx=",sign,
                " ppy=",parseInt(ppy), " dpy=",parseInt(dpy), " dy=",parseInt(dy), 
                " gup=",parseInt(giveupx), " max_dxps=",parseInt(INFO.defend_max_dx_psec), " fmr=",parseInt(pose.femur_length));

    if (INFO.defend_gave_up === true) return [ null, null, tspeed0, tdist ];

    return [ dx, dy, tspeed0, tdist ];
}




// original zombie following defender
//
function DefenderSize(fdata, fdata1) {
    var nheight, dwidth, dheight; 
	var pose = fdata.pose;
    var defender1 = fdata1.defender;

	var top = pose.top;
	var bottom = pose.bottom;
    var height1 = bottom;

    //
    // adjusts vertical defender size
    //
    if((pose.ctr_y < defender1.top) && (defender1.height > 0)) {
        if(pose.top < (defender1.top - 200)){
            nheight = Math.floor((height1 - pose.top) * 1.2);   // player is far back, don't follow
        } else {
            nheight = Math.floor((defender1.height));   // be in front of the player
        }
    } else {
        if(pose.top > defender1.top){
            nheight = Math.floor((height1 - pose.top) * 1.2);   // backup fast
        } else {
            nheight = Math.floor((height1 - pose.top) * 1.2);   // be in front of the player
        }
    }

    nheight = (nheight == 0) ? Math.floor((height1 - top) * 1.5) : nheight;   // can not be zero
    dheight = parseInt(Math.floor((nheight + defender1.height) / 2));
    dwidth = parseInt((dheight) * 0.6);
    //dx = Math.floor((pose.ctr_x)-(dwidth/2)); 

    return [ dheight, dwidth ];
}



// determine key juking metrics
//     - run at every direction change to analyze previous cycle
//     - time to max speed from rest  -  fdata.action.defend_tspeed = vector.tspeed;
//     - max meter per second -  fdata.action.defend_speed
//
function analyzeDirectionChange() {
	var hidx = HISTORY.length - 1;
    var fdata = HISTORY[hidx];
	var action = fdata.action;

    for (var h = hidx; h >= 0; h--) {
         var action = HISTORY[h].action;
         if (action) {
            var tspeed = action.defend_tspeed;


         }

    }
}


//
//    - base: frame of the last turn 
//
function generateDefender(fdata, fdata1, base) {
	var pose = fdata.pose;
	var action = fdata.action;
	var stats = fdata.stats;
    var defender1 = fdata1.defender;
    var restart = null, gaveup = false;

    var [ dheight, dwidth ] =  DefenderSize(fdata, fdata1);
    var [ dx, dy, tspeed0, tdist ] =  DefenderPosition(fdata, fdata1, base);

    if(action.body_flip === true) {
        INFO.defend_restart_time = fdata.timestamp + INFO.defend_cog;        // wait
        INFO.defend_tot_turns = INFO.defend_tot_turns + 1;
    }

    if ((dx === null) && (dy === null)) {
        dx = 0; 
        dy = 0;
        gaveup = true;
    }

    // introduce natural y drift up and down to avoid "static feel"
    var max_ydrift = (INFO.defend_dy_drift_max === null) ? 10 : INFO.defend_dy_drift_max;
    var dy_drift = max_ydrift / CONSTS.DEFENDER_Y_DRIFT_HIDX;
    INFO.defend_dy_drift = (INFO.defend_dy_drift + dy_drift);
    if ((INFO.defend_dy_drift === null) || (Math.abs(INFO.defend_dy_drift) >= Math.abs(INFO.defend_dy_drift_max))) {
        if (INFO.defend_dy_drift_max > 0) {
            INFO.defend_dy_drift_max = -INFO.defend_dy_drift_max;   // reverse course
        } else {
           INFO.defend_dy_drift_max = Math.random() * (CONSTS.DEFENDER_Y_DRIFT_MAX_PCT / 100 * INFO.image_height);  // start new y drift
        }
        INFO.defend_dy_drift = 0;
    }
    var y_drift = INFO.defend_dy_drift;

    // introduce natural x drift left and right to avoid "static feel"
    var max_xdrift = (INFO.defend_dx_drift_max === null) ? 10 : INFO.defend_dx_drift_max;
    var dx_drift = max_xdrift / CONSTS.DEFENDER_X_DRIFT_HIDX;
    INFO.defend_dx_drift = (INFO.defend_dx_drift + dx_drift);
    if ((INFO.defend_dx_drift === null) || (Math.abs(INFO.defend_dx_drift) >= Math.abs(INFO.defend_dx_drift_max))) {
        if (INFO.defend_dx_drift_max > 0) {
            INFO.defend_dx_drift_max = -INFO.defend_dx_drift_max;   // reverse course
        } else {
           INFO.defend_dx_drift_max = Math.random() * (CONSTS.DEFENDER_X_DRIFT_MAX_PCT / 100 * INFO.image_width);  // start new y drift
        }
        INFO.defend_dx_drift = 0;
    }
    var x_drift = INFO.defend_dx_drift;

    var y_offset = parseInt(CONSTS.DEFENDER_Y_OFFSET_PCT / 100 * INFO.image_height);   // shift defender lower

    var d_left = (defender1.left) ? defender1.left : 0;
    var d_top = (defender1.top) ? defender1.top : 0;
    var def_x0 = Math.floor(dx + d_left);   // 
    var def_y0 = Math.floor(dy + d_top);

    var def_dt = fdata.timestamp - fdata1.timestamp;
    var def_x = (def_x0 > 0) ? def_x0 : pose.ctr_x;
    var def_y = (def_y0 > 0) ? def_y0 : pose.ctr_y;
    def_x = (def_x < INFO.image_width) ? def_x : pose.ctr_x;
    def_y = (def_y < INFO.image_height) ? def_y : pose.ctr_y;
    dfconsole_log1("210:      . . . dx=",parseInt(dx)," def_x0=",def_x0, " def_x=",def_x, " xdri=",parseInt(x_drift), " dx_dri=",dx_drift.toFixed(2), " mx_xdri=",parseInt(max_xdrift), " d_left=",d_left, "dy=",parseInt(dy), " def_y0=",def_y0, " def_y=",def_y, " yoff=",y_offset, " ydri=",parseInt(y_drift), " dy_dri=",dy_drift.toFixed(2), " mx_dri=",parseInt(max_ydrift), " d_top=",d_top);

    var show_x = def_x + x_drift;       //x_jitter;
    var show_y = def_y + y_drift + y_offset;

    var display = {}
    display.def_x = def_x;
    display.def_y = def_y;
    display.def_dt = def_dt;
    display.show_x = show_x;
    display.show_y = show_y;
    display.dwidth = dwidth;
    display.dheight = dheight;

    var [ dspeed0, ddistance, ddirection, ddegree ] = calcMoveVector(stats, def_x, defender1.left, def_y, defender1.top, fdata.timestamp, fdata1.timestamp);

    // expon smoothing to have more usable speed curve
    //
    var dspeed = (CONSTS.EXPON_DEFENDER_SPEED * dspeed0) + ((1 - CONSTS.EXPON_DEFENDER_SPEED) * fdata1.action.defend_speed);
    var tspeed = (CONSTS.EXPON_DEFENDER_TARGET_SPEED * tspeed0) + ((1 - CONSTS.EXPON_DEFENDER_TARGET_SPEED) * fdata1.action.defend_tspeed);
    //console.log("301:      . . . tspeed=",tspeed, " tspeed0=",tspeed0, " f1.tspeed=", fdata1.action.defend_tspeed);

    var dvector = {};               // defender metric
    dvector.dspeed0 = dspeed0;
    dvector.dspeed = dspeed;
    dvector.tspeed0 = tspeed0;      // player speed since turn (direction chg), time to reach max is KEY METRIC
    dvector.tspeed = tspeed;        // player speed since turn (direction chg), time to reach max is KEY METRIC
    dvector.tdist = tdist;          // player speed since turn (direction chg), time to reach max is KEY METRIC
    dvector.dist = ddistance;       // player distance to defender
    dvector.direction = ddirection;
    dvector.degree = ddegree;
    dvector.restart = restart;
    dvector.gaveup = gaveup;

    return [ display, dvector ];
}



//
//     - calc player direction, speed, acceleration
//     - bot: reaction_delay, max_acceleration, persistence, unit = femur_pixel
//
export function showDefender(canvas) {
    var hidx = HISTORY.length - 1;
	var fdata = HISTORY[hidx];
	var fdata1 = HISTORY[hidx-1];       // immediately previous
    var context = canvas.getContext('2d');
    var fdata2 = null;  // turning point

    if((INFO.show_defender == false) || (HISTORY.length < 5))  return;

    // identify last direction change to calc speed & distance
    //
    for (var h = (hidx - 1); h > 0; h--) {
        var f = HISTORY[h];
        if (f.action.body_flip === true) {
            fdata2 = f;     // direction changed
            dfconsole_log("293:         . . .  DEFENDER: LAST TURN   hidx=",h, "  x=", fdata2.pose.ctr_x );
            break;
        }
    }

    //INFO.defend_max_dx_psec = calcMeter2Pixel(STATS.pixel_ratio, INFO.defend_acc);     // pixel_ratio may change
    INFO.defend_max_dx_psec = calcFemur2Pixel(INFO.defend_acc);     // max pixel move per second


    var [ display, vector ] = generateDefender(fdata, fdata1, fdata2);
    var dx = display.def_x - fdata1.defender.left;  // if next frame is to continue at same velocity
    var dx_ps = dx / (display.def_dt / 1000);  // if next frame is to continue at same velocity
    dfconsole_log1("243:         . . .  def_x=",display.def_x, " f1.x=", fdata1.defender.left, " dx=",parseInt(dx), " dt=",display.def_dt, " dx_ps=",parseInt(dx_ps), " defend_max_dx_psec=",INFO.defend_max_dx_psec, " femur=", INFO.ref_femur, " dspd=",vector.dspeed, " tspd0=",vector.tspeed0, " tspd=",vector.tspeed);
    //console.log("243:         . . .  def_x=",display.def_x, " f1.x=", fdata1.defender.left, " dx=",parseInt(dx), " dt=",display.def_dt, " dx_ps=",parseInt(dx_ps), " defend_max_dx_psec=",INFO.defend_max_dx_psec, " femur=", INFO.ref_femur, " dspd=",vector.dspeed, " tspd0=",vector.tspeed0, " tspd=",vector.tspeed);

    // draw defender
    //
    var show_x = Math.floor(display.show_x - (display.dwidth / 2));
    var show_y = Math.floor(display.show_y)
    var defender_image = defenderImage(same_cnt, Defender_type);
    context.globalAlpha = 0.7;
	context.drawImage(defender_image, show_x, show_y, display.dwidth, display.dheight);

    if ((INFO.defend_gave_up === true) || (vector.gaveup === true)) {

        var fsize = ((360 + 270) / 30);         // * INFO.scale_font;
        displayText("red", fsize, "DEFENDER GAVE UP!", 50, 100);
        dfconsole_log("287:    > > > > >  INFO.give_up=",INFO.defend_gave_up, " gaveup=", parseInt(vector.gaveup), " pose_x=",fdata.pose.ctr_x," show_x=",show_x, " show_y=",show_y, " dwidth=",display.dwidth, " dheight=",display.dheight, " fsize=",fsize);
        if (INFO.defend_gave_up === false) {
            INFO.beat_defender = true;      // for stats gathering later
        }

        INFO.defend_gave_up = true;     // for display
        setTimeout(()=> {
            INFO.defend_gave_up = false;        // reset
        }, CONSTS.DEFENDER_RECOVER_MSEC);
    }

    // defender render info
    //
    fdata.defender.type = Defender_type;
    fdata.defender.top = display.def_y;
    fdata.defender.left = display.def_x;
    fdata.defender.height = display.dheight;
    fdata.defender.width = display.dwidth;

    // defender action stats
    //
    fdata.action.defend_speed0 = vector.dspeed0;
    fdata.action.defend_speed = (vector.dspeed) ? vector.dspeed : vector.dspeed0;
    fdata.action.defend_tspeed0 = vector.tspeed0;
    fdata.action.defend_tspeed = (vector.tspeed) ? vector.tspeed : vector.tspeed0;

    //fdata.action.defend_dist = Math.floor(vector.distance);
    fdata.action.defend_tdist = vector.tdist;       // KLUDGE: player distance from the turn, really should be elsewhere!
    fdata.action.defend_dist = vector.dist;


    fdata.action.defend_degree = Math.floor(vector.degree);
    fdata.action.defend_dx_ps = (dx_ps) ? dx_ps : 0;      // dx pixel per second, if we want to continue
    fdata.action.defend_restart = vector.restart;    // cognition delay after a player turn
    fdata.action.gaveup = vector.gaveup;

    same_cnt = (same_cnt + 1) % 25;    // determine rate image variations
}



// determine defender image
//    - create fine grain animation sequence here
//
const defenderImage = (same_cnt, Defender_type) => {
    var defender_image = null;

    //console.log("def.48: ***  def_x=",def_x, " def_y=", def_y, " dx=",dx, " d.left=",defender1.left, " dy=", dy, " d.top=",defender1.top);
    Defender_type = ((Math.random()*same_cnt) < 10) ? Defender_type :       // higher more static
                    ((Math.random()*same_cnt) > 5) ? 1 : 2;
    defender_image = (Defender_type == 1) ? Defender_image1 : Defender_image2;

    defender_image = Defender_image1;   // KLUDGE: OVERRIDE FOR NOW
    return defender_image
}



const defender1_path = "images/defender_henry1.png"
const defender2_path = "images/defender_henry2.png"
var Defender_image1=null;
var Defender_image2=null;
//var Defender_image = null;	// cache of last used
var Defender_type = 1;	    // cache of last used
var same_cnt = 0;
export async function initDefender() {
    Defender_image1 = await loadImage(defender1_path);
    Defender_image2 = await loadImage(defender2_path);
    Defender_type = 1;
    same_cnt = 0;

    INFO.defend_gave_up = false;
    INFO.defend_max_dx_psec = null;            // max pixel movement per second, normalized with femur (~200)
    INFO.defend_restart_time = null;           // time with cognition delay
    INFO.defend_tot_turns = 0;
}